import {AbstractControl} from '@angular/forms';

/**
 * Returns true if at least one checkbox in a multicheckbox group is checked. Otherwise, returns false.
 */
export const MulticheckboxRequiredValidator = (control: AbstractControl): boolean => {
  const values: boolean[] = control.value ? Object.values(control.value) : [];

  for (const value of values) {
    if (value) {
      return true; // At least one checkbox is checked
    }
  }

  return false; // No checkboxes are checked
};
